import React from 'react'
import CustomTextField from '../../components/MaterialUi/CustomTextField'

const ImageCateLabel=props=>{
    return (
        <div style={{paddingTop: '5px',paddingBottom: '5px'}}>
           <CustomTextField label={props.labelDict.label} value={props.labelDict.desc} /> 
        </div>
    )
}

const ImageCateDicts=props=>{
    return (
        <div style={{paddingTop: '5px',paddingBottom: '5px'}}>
            {props.labels.map(label => {
                return <ImageCateLabel key={label.label} labelDict={label}/>
            })}
        </div>    
    )
}

export default ImageCateDicts


// WEBPACK FOOTER //
// ./src/views/ImageSegmentQuestion/ImageCateDicts.js